import React from 'react'
import IconBadge from '../../../ui/iconBadge'
import Wrapper from '../../../ui/wrapper'
import { Badge } from '../mapper'

type FirmBadgesProps = {
  badges: Badge[] | null
  color: string
}

const BadgesCard: React.FC<FirmBadgesProps> = ({ badges, color }) => {
  if (!badges || badges.length === 0) {
    return null
  }

  const badgesToDispay = badges.filter(
    (badge) => badge?.uuid && badge?.name,
  ) as {
    name: string
    uuid: string
  }[]

  return (
    <Wrapper>
      <ul className="p-2 space-y-2">
        <p className="pl-2 text-lg font-semibold text-left text-gray-900">
          Nos badges
        </p>
        {badgesToDispay.map(({ name, uuid }) => (
          <li key={uuid} className="flex items-center space-x-2" title={name}>
            <div>
              <IconBadge
                icon={uuid}
                color={color}
                className="w-10 h-10 rounded-3xl"
              />
            </div>
            <span className="text-gray-800">{name}</span>
          </li>
        ))}
      </ul>
    </Wrapper>
  )
}

export default BadgesCard
